'use strict';exports.__esModule = true;exports.sendContactUsClientForm = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var initialState = {
  loading: false,
  loaded: false,
  error: null };


var sendContactUsClientForm = (0, _reduxAct.createAction)('/SEND_CONTACT_US_CLIENT_FORM');
var sendContactUsClientFormSuccess = (0, _reduxAct.createAction)('/SEND_CONTACT_US_CLIENT_FORM_SUCCESS');
var sendContactUsClientFormError = (0, _reduxAct.createAction)('/SEND_CONTACT_US_CLIENT_FORM_ERROR');

var fetchPost = function fetchPost(_ref) {var data = _ref.data,token = _ref.token;return (
    _axios2.default.post('/leads/buy_custom', data, { headers: { access_token: token } }).
    then(sendContactUsClientFormSuccess, sendContactUsClientFormError));};

var handler = function handler(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchPost, data));};

var handlerSuccess = function handlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    error: null,
    data: response.data });};


var handlerError = function handlerError(state, response) {
  var error = (0, _formatApiError2.default)(response, 'property');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error,
    data: undefined });

};

var contactUsClientForm = (0, _reduxAct.createReducer)(function (on) {
  on(sendContactUsClientForm, handler);
  on(sendContactUsClientFormSuccess, handlerSuccess);
  on(sendContactUsClientFormError, handlerError);
}, initialState);exports.

sendContactUsClientForm = sendContactUsClientForm;exports.default =

contactUsClientForm;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/contactUsClientForm.js
// module id = 1280
// module chunks = 0